// import { ColorModeScript } from '@chakra-ui/react';
import React from 'react'
import { createRoot } from 'react-dom/client'
import App from './App'
import { initializeTracking } from './containers/repository/repo.utils'
import { BrowserRouter } from 'react-router-dom'

// Jul 2023 onwards Tracking ID will be removed
;(function initGAnalytics() {
	initializeTracking()
})()

const container = document.getElementById('root')
const root = createRoot(container)

root.render(
	<React.StrictMode>
		<BrowserRouter>
			<App />
		</BrowserRouter>
	</React.StrictMode>
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
// serviceWorker.unregister();
